import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

import { PhxCheckboxModule } from '../checkbox/checkbox.module';

import { PhxListComponent, PhxListItemComponent } from './list.component';
import { PhxListItemAvatarDirective } from './list-item-avatar.directive';
import { PhxListItemPreDirective } from './list-item-pre.directive';
import { PhxListItemTextLineDirective } from './list-item-text-line.directive';
import { PhxListItemActionDirective } from './list-item-action.directive';
import { PhxListItemPostDirective } from './list-item-post.directive';

@NgModule({
  declarations: [
    PhxListItemAvatarDirective,
    PhxListItemPreDirective,
    PhxListItemTextLineDirective,
    PhxListItemActionDirective,
    PhxListItemPostDirective,
    PhxListComponent,
    PhxListItemComponent,
  ],
  exports: [
    PhxListComponent,
    PhxListItemComponent,
    PhxListItemAvatarDirective,
    PhxListItemPreDirective,
    PhxListItemTextLineDirective,
    PhxListItemActionDirective,
    PhxListItemPostDirective
  ],
  imports: [
    CommonModule,
    A11yModule,
    PhxCheckboxModule,
  ],
  providers: [],
})
export class PhxListModule { }
